import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { CUTOVER } from '@/data/migration/model';
import useRipplingMigration from '@/rippling/hooks/useRipplingMigration';
import { isImpersonatingSession } from '@/shared/auth/auth';
import { getAuthUser } from '@/shared/auth/selectors';
import { useWiwSelector } from '@/store';

const BILLING_PATH = /^\/billing\/?$/i; // must be "/billing" or "/billing/"

export default function RipplingMigrationGuard() {
  const location = useLocation();
  const history = useHistory();

  const currentUser = useWiwSelector(getAuthUser);

  const { migrationLoaded, migrationStep } = useRipplingMigration();

  useEffect(() => {
    if (!migrationLoaded) {
      return;
    }

    if (migrationStep !== CUTOVER) {
      return;
    }

    // WIW care specialists impersonating an account via the x-ray tool need to
    // inspect the migrated account directly. Skip the cutover redirect so they
    // can navigate the app instead of being locked to the splash page.
    if (isImpersonatingSession()) {
      return;
    }

    // this will only return if this user is Admin and they're already on the billing page
    if (currentUser.isAdmin() && BILLING_PATH.test(location.pathname)) {
      return;
    }

    if (currentUser.isAdmin()) {
      history.replace('/billing');
      return;
    }

    history.replace('/wiw-is-now-rippling');
  }, [migrationLoaded, migrationStep, location.pathname]);

  return null;
}
